import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";
import { Localvalue } from "../../nametitle/localValue";
import { saveDataToFile } from "../SearchAction";


// Créer un School
export const CreateSchool = (title, coverPicture, description, video, audio, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "coverPicture": coverPicture,
    "description": description,
    "video": video,
    "audio": audio,
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/activites/school`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      window.location.reload();
      redirect(`/${AllRoutes.admin}/${AllRoutes.activity}`);
    })
    .catch(function (error) {
      // console.log(error);
    });
}

// Mise ajour du Témoignage
export const UpdateSchool = (id, title, coverPicture, description, video, audio, visible, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "coverPicture": coverPicture,
    "description": description,
    "video": video,
    "audio": audio,
    "visible": visible
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/activites/school/edit/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      // redirect(`/${AllRoutes.admin}/${AllRoutes.userlist}`);
      window.location.reload();
    })
    .catch(function (error) {
      // console.log(error);
      alert("Update video failed")
    });

}







// Recupérer tout les programes
export const LoadAllSchool = (SetState, SetState2) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/activites/school/get/all`, {
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      saveDataToFile(response.data.data,Localvalue.enseignementsData);
      SetState(response.data.data);
      SetState2(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
}

export const LoadAllSchoolId = (id, SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/activites/school/get_school/${id}`, {
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      SetState(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
}



